import baseRoute from '../baseRoute';

export default `${baseRoute}/fieldWorkClassificationCode` as const;
